/**
 * Burger menu component
 */

import * as React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import { slide as Menu } from "react-burger-menu";
import { AnchorLink } from "gatsby-plugin-anchor-links";
import "../styles/burger-menu.css";

const BurgerMenu = () => {
  const data = useStaticQuery(graphql`
    {
      allMenuItems(
        filter: { menu_name: { eq: "main" }, parent: { id: { eq: null } } }
      ) {
        nodes {
          url
          childrenMenuItems {
            url
            childrenMenuItems {
              url
              title
            }
            title
          }
          title
        }
      }
      menuItems(menu_name: { eq: "main-navigation-button" }) {
        title
        url
      }
    }
  `);
  const menuItems = data?.allMenuItems?.nodes;
  const cta = data?.menuItems;
  return (
    <div className="block xl:hidden burger-menu menu print:hidden">
      <Menu
        right
        width={"min(90%, 330px)"}
        aria-hidden
        pageWrapId={"main-content"}
        outerContainerId={"global-wrapper"}
      >
        <Link to="/" className="mb-8 outline-none">
          <img
            loading="lazy"
            className="w-48 grow"
            src="/images/CommunityFoundationLogo.svg"
            alt="Community Foundation of Northern Nevada Logo"
          />
        </Link>
        {cta && (
          <div>
            <a className="menu-link btn btn-red" href={cta.url}>
              {cta.title}
            </a>
          </div>
        )}
        {menuItems?.length ? (
          <>
            {menuItems.map((c1, index) => {
              const isExternal = c1.url?.startsWith("http");
              return (
                <>
                  {c1.childrenMenuItems?.length ? (
                    <div key={"menu-" + index} className="mt-4">
                      <div className={`menu-link cursor-default font-medium`}>
                        {c1.title ? c1.title : null}
                      </div>
                      <ul className="pl-2 ml-2 py-2 border-l submenu bg-white bg-opacity-30">
                        {c1.childrenMenuItems.map((c2, index2) => {
                          const isExternal = c2.url?.startsWith("http");
                          return (
                            <li
                              key={"menu-" + index + "-" + index2}
                              className="my-2"
                            >
                              <Link
                                className={`menu-link block my-1`}
                                key={c2.url}
                                to={c2.url}
                                target={c2.target || isExternal ? "_blank" : "_self"}
                              >
                                {c2.title}
                              </Link>
                              {c2.childrenMenuItems?.length ? (
                                <ul className="pl-2 ml-2 py-2 border-l submenu bg-white bg-opacity-40">
                                  {c2.childrenMenuItems.map((c3, index3) => {
                                    const isExternal = c3.url?.startsWith("http");
                                    return <li
                                      key={
                                        "menu-" +
                                        index +
                                        "-" +
                                        index2 +
                                        "-" +
                                        index3
                                      }
                                      className={``}
                                    >
                                      <Link
                                        className="menu-link text-gray"
                                        to={c3.url}
                                        target={c3.target || isExternal ? "_blank" : "_self"}
                                      >
                                        {c3.title}
                                      </Link>
                                    </li>
                                  })}
                                </ul>
                              ) : null}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  ) : (
                    <div key={"menu-" + index} className="mt-4">
                      <a href={c1.url} className={`menu-link`} rel="noreferrer" target={c1.target || isExternal ? "_blank" : "_self"}>
                        {c1.title ? c1.title : null}
                      </a>
                    </div>
                  )}
                </>
              );
            })}
          </>
        ) : null}
        <AnchorLink className="menu-link menu-link-last" to="#translate">
          <span>
            <span className="sr-only">Language Selection</span>
            <img
              className="w-8 grow my-2"
              src="/images/united-states-flag.svg"
              alt=""
            />
          </span>
        </AnchorLink>
      </Menu>
    </div>
  );
};

export default BurgerMenu;
